export const solrPageGetParameter = "tx_solr[page]";
export const solrTermFilterGetParameter = "tx_solr[q]";
export const solrFacetFilterGetParameterRegex = /^tx_solr\[filter]\[[0-9]+]$/;
